var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsOfUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M52.01 7c4.316 0 7.832 3.516 7.832 7.832v32.07c0 4.317-3.516 7.833-7.832 7.833H40.604l-8.428 9.082c-.703.713-1.602 1.094-2.569 1.094a3.554 3.554 0 0 1-3.535-3.535v-6.641h-6.24c-4.316 0-7.832-3.516-7.832-7.832V14.832C12 10.516 15.516 7 19.832 7Zm0 3.008H19.832a4.822 4.822 0 0 0-4.824 4.824v32.07a4.822 4.822 0 0 0 4.824 4.825h7.744c.83 0 1.504.674 1.504 1.504v8.145c0 .215.127.42.322.488.342.029.49-.02.596-.117l8.848-9.541a1.529 1.529 0 0 1 1.103-.48H52.01a4.822 4.822 0 0 0 4.824-4.823V14.832a4.822 4.822 0 0 0-4.824-4.824ZM37.631 26.45c.454 0 .908.37.908.907v17.236c0 .494-.454.907-.908.907h-3.34c-.453 0-.906-.413-.906-.907V27.357c0-.536.453-.907.906-.907ZM35.9 16.636c1.855 0 3.299 1.443 3.299 3.257 0 1.815-1.444 3.3-3.3 3.3-1.854 0-3.256-1.485-3.256-3.3 0-1.814 1.402-3.257 3.257-3.257Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsOfUse);
export default __webpack_public_path__ + "static/media/TermsOfUse.b279fe03d6a817d5df5f5d06a23b0d14.svg";
export { ForwardRef as ReactComponent };